import { Dispatch } from 'redux';
import React from 'react';
import { AppState } from 'acscp/store';
import { FetchRequest } from 'acscp/actions';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { BaseRequest } from 'acscp/api/requests';
import { RequestStateProps } from 'acscp/components/common/helpers/requestStateProps';
import style from './viewPdfButton.module.scss';
import { connectWithRequests } from 'acscp/store/helpers/connectWithRequests';
import { ButtonWithLoadingIndicator } from 'acscp/components/common/buttonWithLoadingIndicator';
import classNames from 'classnames';

interface ViewPdfButtonOwnProps {
    pdfUrlRequest: BaseRequest<any>;
    pdfId: string;
    isGreyedOut?: boolean;
    isDarkBlue?: boolean;
}

type ViewPdfButtonStateProps = RequestStateProps;

interface ViewPdfButtonDispatchProps {
    viewPdf: () => void;
}

type ViewPdfButtonProps = ViewPdfButtonOwnProps & ViewPdfButtonStateProps & ViewPdfButtonDispatchProps;

const ViewPdfButtonPresentational: React.SFC<ViewPdfButtonProps> = props => {
    const clickHandler = () => {
        if (!OPEN_FILES_AS_MOBILE) {
            /**
             * The PDF should be open in a new window for viewing.
             * Modern browsers prevent creation of popups unless it is done as a reaction to user
             * action - a click in this case. We can't wait till API request success/fail.
             *
             * We use the PDF ID as the popup target,
             * so it would be possible to open the actual PDF link in that exact popup.
             */
            window.open('about:blank', props.pdfId);
        }
        props.viewPdf();
    };

    return (
        <ButtonWithLoadingIndicator
            className={classNames(style.Button,
                {
                    [style.GreyedOut]: props.isGreyedOut,
                    [style.ButtonDarkBlue]: props.isDarkBlue,
                })}
            onClick={clickHandler}
            isLoading={props.isLoading}
        >
            <FormattedMessage id={'components.viewPdf.viewPdfButton.text'} defaultMessage={'View PDF'} />
        </ButtonWithLoadingIndicator>
    );
};

export { ViewPdfButtonPresentational };

function mapStateToProps(
    state: AppState, ownProps: ViewPdfButtonOwnProps, getRequestError: (request: BaseRequest<any>) => RequestStateProps
): ViewPdfButtonStateProps {
    return getRequestError(ownProps.pdfUrlRequest);
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: ViewPdfButtonOwnProps): ViewPdfButtonDispatchProps {
    return {
        viewPdf: () => dispatch(new FetchRequest(ownProps.pdfUrlRequest))
    };
}

export const ViewPdfButton = connectWithRequests(mapStateToProps, mapDispatchToProps)(ViewPdfButtonPresentational);
